// extracted by mini-css-extract-plugin
export default {"button":"mn-z","reviewSort":"nn-z"};